import { getBodyweightTrend } from './bodyweight-trend'
import { createRoutine } from './create-routine'
import { createRoutineFolder } from './create-routine-folder'
import { getCurrentSplit } from './current-split'
import { getDetectedPlateaus } from './detected-plateaus'
import { getExerciseHistory } from './exercise-history'
import { generateGraph } from './generate-graph'
import { getCurrentAppState } from './get-app-state'
import { lookupExerciseTemplateID } from './lookup-exercise-template'
import { searchExerciseLibrary } from './search-exercise-library'
import { searchUserExercises } from './search-user-exercises'
import { getUserPerformanceMetrics } from './performance-metrics'
import { getRecentWorkouts } from './recent-workouts'
import { toolRegistry } from './registry'

// Register all tools
toolRegistry.register(getUserPerformanceMetrics)
toolRegistry.register(getCurrentSplit)
toolRegistry.register(getRecentWorkouts)
toolRegistry.register(lookupExerciseTemplateID) // Deprecated - use searchExerciseLibrary or searchUserExercises
toolRegistry.register(searchExerciseLibrary)
toolRegistry.register(searchUserExercises)
toolRegistry.register(getExerciseHistory)
toolRegistry.register(getBodyweightTrend)
toolRegistry.register(generateGraph)
toolRegistry.register(createRoutineFolder)
toolRegistry.register(createRoutine)
toolRegistry.register(getCurrentAppState)
toolRegistry.register(getDetectedPlateaus)

export type { AITool, ToolContext } from './types'
export { toolRegistry }
